import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";

import { Banner } from "./Banner";
import { Section1 } from "./Section1";
import { Section2 } from "./Section2";
import { Section3 } from "./Section3";
import { Section4 } from "./Section4";
import { Section1Preview } from "./Section1/Preview";
import { Section2Preview } from "./Section2/Preview";
import { Section3Preview } from "./Section3/Preview";
import { Section4Preview } from "./Section4/Preview";
import { useSelector } from "react-redux";

export function CoverPage() {
    const [deviceType, setDeviceType] = React.useState<"Desktop" | "Mobile">(
        "Desktop"
    );
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);
    const tabs: TabsType[] = [
        {
            title: t("Banner"),
            content: (
                <Banner deviceType={deviceType} setDeviceType={setDeviceType} />
            ),
            customClassName: "",
        },
        {
            title: t("Section 1"),
            content: (
                <Section1
                    deviceType={deviceType}
                    setDeviceType={setDeviceType}
                />
            ),
            customClassName: "",
        },
        {
            title: t("Section 2"),
            content: (
                <Section2
                    deviceType={deviceType}
                    setDeviceType={setDeviceType}
                />
            ),
            customClassName: "",
        },
        {
            title: t("Section 3"),
            content: <Section3 />,
            customClassName: "",
        },
        {
            title: t("Section 4"),
            content: <Section4 />,
            customClassName: "",
        },
    ];
    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <div className="d-flex justify-content-between">
            {activeTab !== 0 ? (
                <div style={{ width: "50% " }}>
                    <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                        <Nav
                            tabs
                            style={{
                                backgroundColor: "white",
                                width: "50px",
                                display: "grid",
                                gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                                border: "unset",
                            }}
                        >
                            {tabs.map((element, index) => {
                                return (
                                    <NavItem
                                        key={index}
                                        className={classNames(
                                            "pb-1",
                                            "d-flex align-items-center text-nowrap",
                                            {
                                                "disable-nav-item__clz":
                                                    activeTab !== index,
                                            },
                                            element.customClassName
                                        )}
                                        style={{
                                            cursor: "pointer",
                                            borderBottom:
                                                activeTab === index
                                                    ? `${mainColor} 3px solid`
                                                    : "",
                                        }}
                                    >
                                        <NavLink
                                            className={classNames(
                                                "text-dark w-100",
                                                {
                                                    "active customer-account-menu-nav-link-active__clz":
                                                        activeTab === index,
                                                    "customer-account-menu-nav-link-disable__clz":
                                                        activeTab !== index,
                                                }
                                            )}
                                            onClick={() => {
                                                toggleNav(index);
                                            }}
                                        >
                                            <span
                                                className="px-2"
                                                style={{
                                                    font:
                                                        "normal normal 600 20px/27px  Segoe UI",
                                                }}
                                            >
                                                {element.title}
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                );
                            })}
                        </Nav>
                    </div>
                    <TabContent activeTab={activeTab} className="h-100">
                        {tabs.map((element, index) => {
                            return (
                                <TabPane
                                    tabId={index}
                                    key={index}
                                    style={{ height: "90%" }}
                                >
                                    {element.content}
                                </TabPane>
                            );
                        })}
                    </TabContent>
                </div>
            ) : (
                <div style={{ width: "100% " }}>
                    <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                        <Nav
                            tabs
                            style={{
                                backgroundColor: "white",
                                width: "50px",
                                display: "grid",
                                gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                                border: "unset",
                            }}
                        >
                            {tabs.map((element, index) => {
                                return (
                                    <NavItem
                                        key={index}
                                        className={classNames(
                                            "pb-1",
                                            "d-flex align-items-center text-nowrap",
                                            {
                                                "disable-nav-item__clz":
                                                    activeTab !== index,
                                            },
                                            element.customClassName
                                        )}
                                        style={{
                                            cursor: "pointer",
                                            borderBottom:
                                                activeTab === index
                                                    ? `${mainColor} 3px solid`
                                                    : "",
                                        }}
                                    >
                                        <NavLink
                                            className={classNames(
                                                "text-dark w-100",
                                                {
                                                    "active customer-account-menu-nav-link-active__clz":
                                                        activeTab === index,
                                                    "customer-account-menu-nav-link-disable__clz":
                                                        activeTab !== index,
                                                }
                                            )}
                                            onClick={() => {
                                                toggleNav(index);
                                            }}
                                        >
                                            <span
                                                className="px-2"
                                                style={{
                                                    font:
                                                        "normal normal 600 20px/27px  Segoe UI",
                                                }}
                                            >
                                                {element.title}
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                );
                            })}
                        </Nav>
                    </div>
                    <TabContent activeTab={activeTab} className="h-100">
                        {tabs.map((element, index) => {
                            return (
                                <TabPane
                                    tabId={index}
                                    key={index}
                                    style={{ height: "90%" }}
                                >
                                    {element.content}
                                </TabPane>
                            );
                        })}
                    </TabContent>
                </div>
            )}
            {activeTab !== 0 && (
                <div style={{ width: "50%" }}>
                    {activeTab === 1 && (
                        <Section1Preview
                            deviceType={deviceType}
                            section="Section1"
                        />
                    )}
                    {activeTab === 2 && (
                        <Section2Preview
                            deviceType={deviceType}
                            section="Section2"
                        />
                    )}
                    {activeTab === 3 && <Section3Preview section="Section3" />}
                    {activeTab === 4 && <Section4Preview section="Section4" />}
                </div>
            )}
        </div>
    );
}
